import { Container } from './styles';

const TooltipClipboard = ({ children, showTooltip }) => {
  return <Container showTooltip={showTooltip}>{children}</Container>;
};

export default TooltipClipboard;
